import { Fragment, useEffect, useState } from "react";
import client from "../../../api/camasirhaneApi";
import { MONTHS, YEARS, formatNum } from "../utils/constants";
import { downloadDashboardExcelReport } from "../utils/dashboardExcelReport";
import { periodSummaryToExportData } from "../utils/periodExportData";
import "../styles/shared.css";

export default function SummaryTotalsScreen() {
  const [year, setYear] = useState(2026);
  const [month, setMonth] = useState(7);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    setLoading(true);
    client.get("/reports/period-summary/", { params: { year, month } })
      .then((res) => setData(res.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [year, month]);

  async function handleExport() {
    if (!data) return;
    setExporting(true);
    try {
      const exportData = periodSummaryToExportData(data);
      await downloadDashboardExcelReport({
        periodLabel: `${MONTHS[month - 1]} ${year}`,
        year,
        months: [month],
        ...exportData,
        filename: `camasirhane_rapor_${MONTHS[month - 1]}_${year}.xlsx`,
      });
    } finally {
      setExporting(false);
    }
  }

  const grand = data?.grand_totals;

  return (
    <div className="screen">
      <div className="screen-header">
        <h2>Genel Toplam</h2>
        <p>Tüm otellerin kirli, temiz ve üretim özetleri — otomatik hesaplanır</p>
      </div>

      <div className="toolbar">
        <select className="ui-select" value={month} onChange={(e) => setMonth(Number(e.target.value))}>
          {MONTHS.map((name, i) => <option key={name} value={i + 1}>{name}</option>)}
        </select>
        <select className="ui-select" value={year} onChange={(e) => setYear(Number(e.target.value))}>
          {YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
        <button className="ui-btn ui-btn--ghost" onClick={handleExport} disabled={!data || exporting}>
          {exporting ? "Hazırlanıyor..." : "Excel İndir"}
        </button>
        {loading && <span className="status-msg">Yükleniyor...</span>}
      </div>

      {grand && (
        <div className="summary-cards">
          <div className="summary-card"><h3>Kirli Tartım</h3><p>{formatNum(grand.dirty_kg, 1)} kg</p></div>
          <div className="summary-card"><h3>Temiz Tartım</h3><p>{formatNum(grand.clean_kg, 1)} kg</p></div>
          <div className="summary-card"><h3>Üretim</h3><p>{formatNum(grand.production_kg, 1)} kg</p></div>
          <div className="summary-card"><h3>Kirli − Temiz</h3><p>{formatNum(grand.dirty_clean_diff_kg, 1)} kg</p></div>
          <div className="summary-card"><h3>Temiz − Üretim</h3><p>{formatNum(grand.clean_production_diff_kg, 1)} kg</p></div>
        </div>
      )}

      <div className="grid-wrapper">
        <table className="data-grid">
          <thead>
            <tr>
              <th className="sticky-col label-col">Otel</th>
              <th className="num">Kirli (kg)</th>
              <th className="num">Temiz (kg)</th>
              <th className="num">Üretim (kg)</th>
              <th className="num">Kirli − Temiz</th>
              <th className="num">Temiz − Üretim</th>
            </tr>
          </thead>
          <tbody>
            {data?.hotels?.map((hotel) => (
              <Fragment key={hotel.hotel_id}>
                <tr>
                  <td className="sticky-col label-col">{hotel.hotel_name}</td>
                  <td className="num">{formatNum(hotel.dirty_kg, 1)}</td>
                  <td className="num">{formatNum(hotel.clean_kg, 1)}</td>
                  <td className="num">{formatNum(hotel.production_kg, 1)}</td>
                  <td className="num">{formatNum(hotel.dirty_clean_diff_kg, 1)}</td>
                  <td className="num">{formatNum(hotel.clean_production_diff_kg, 1)}</td>
                </tr>
                {hotel.departments?.map((dept) => (
                  <tr key={`${hotel.hotel_id}-${dept.department_id}`} className="subtotal-row">
                    <td className="sticky-col label-col" style={{ paddingLeft: 24 }}>↳ {dept.department_name}</td>
                    <td className="num">{formatNum(dept.dirty_kg, 1)}</td>
                    <td className="num">{formatNum(dept.clean_kg, 1)}</td>
                    <td className="num">-</td>
                    <td className="num">{formatNum(dept.difference_kg, 1)}</td>
                    <td className="num">-</td>
                  </tr>
                ))}
              </Fragment>
            ))}
          </tbody>
          {grand && (
            <tfoot>
              <tr>
                <td className="sticky-col label-col">Genel Toplam</td>
                <td className="num grand-total">{formatNum(grand.dirty_kg, 1)}</td>
                <td className="num grand-total">{formatNum(grand.clean_kg, 1)}</td>
                <td className="num grand-total">{formatNum(grand.production_kg, 1)}</td>
                <td className="num grand-total">{formatNum(grand.dirty_clean_diff_kg, 1)}</td>
                <td className="num grand-total">{formatNum(grand.clean_production_diff_kg, 1)}</td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
}
